<template>
  <div>
    <h1>Edit Contact</h1>

    <contact :contact="contact" :submit="handleSubmit" @done="handleDone" v-if="contact"></contact>
  </div>
</template>

<script>
import ContactsService from '../../services/ContactsService'
import Contact from '../../components/Contacts/Forms/Contact.vue'

export default {
  components: {
    Contact
  },
  data () {
    return {
      contact: null
    }
  },
  methods: {
    loadContact () {
      const id = parseInt(this.$route.params.id)
      // load the contact
      ContactsService.getContact(id).then((contact) => {
        // set contact to the data
        this.contact = Object.assign({}, contact)
      })
    },
    handleSubmit (contactData) {
      return new Promise((resolve, reject) => {
        // filter the data to only include the allowed keys for GraphQL type
        const filtered = this.$helpers.filterObject(contactData, [
          'salutation', 'first_name', 'last_name', 'organization_name', 'is_organization',
          'bio', 'employments', 'addresses', 'emails', 'phones', 'socials', 'tags', 'ngp_id', 'customFields', 'aliases'
        ])
        if (filtered.employments) {
          filtered.employments = filtered.employments.map(record => this.$helpers.filterObject(record, [
            'id', 'employer', 'occupation', 'is_primary'
          ]))
        }
        if (filtered.socials) {
          // only keep relevant values
          filtered.socials = filtered.socials.map(obj => this.$helpers.filterObject(obj, ['id', 'source', 'url']))
        }
        if (filtered.addresses) {
          filtered.addresses = filtered.addresses.map(record => this.$helpers.filterObject(record, [
            'id', 'line_1', 'line_2', 'city', 'state', 'zip_code', 'country', 'type', 'is_primary'
          ]))
        }
        if (filtered.emails) {
          filtered.emails = filtered.emails.map(record => this.$helpers.filterObject(record, [
            'id', 'email', 'type', 'is_primary'
          ]))
        }
        if (filtered.phones) {
          filtered.phones = filtered.phones.map(record => this.$helpers.filterObject(record, [
            'id', 'number', 'type', 'is_primary'
          ]))
        }
        if (filtered.customFields) {
          filtered.customFields = filtered.customFields.map(record => this.$helpers.filterObject(record, [
            'custom_field_id', 'value'
          ]))
        }
        // submit data
        ContactsService.updateContact(contactData.id, filtered)
          .then((response) => {
            resolve(response)
          })
          .catch(reject)
      })
    },
    handleDone (contactData) {
      this.$notifications.feedbackNotification('Contact updated', 'success')
      this.$router.push({ name: 'contact', params: { id: contactData.id } })
    }
  },
  created () {
    this.loadContact()
  }
}
</script>
